export default class ProductIcon {
    // eslint-disable-next-line no-useless-constructor
    constructor(public id: number, public path: string) {}
}
